export default __webpack_public_path__ + "static/media/m3.317c867e.png";